import { defineComponent as _defineComponent } from 'vue'
import BaseButton from 'JS/components/BaseButton.vue';
import { computed, useListeners } from 'vue';
import { format } from 'date-fns';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarDate',
  props: {
    day: null,
    disabled: { type: Boolean },
    selected: { type: Boolean },
    active: { type: Boolean },
    today: { type: Boolean },
    size: { default: "responsive" }
  },
  setup(__props: any) {

const props = __props as { day: Date, disabled?: boolean, selected?: boolean, active?: boolean, today?: boolean, size: 'sm'|'lg'|'responsive' }



const $listeners = useListeners();
const listeners = computed(() => ({
	...$listeners,
	click: (e: MouseEvent & { currentTarget: HTMLElement }) => {
		// https://zellwk.com/blog/inconsistent-button-behavior/
		e.currentTarget.focus();
		($listeners.click as Function)?.(e);
	}
}));

const ariaLabel = computed(() => format(props.day, 'MMMM do, Y') + " " + (props.selected == true ? 'selected' : 'unselected'));
const dateStringAttr = computed(() => CSS.escape(props.day.toDateString().replace(/\s+/g, '')));
const determineClasses = computed(() => {
	let retClasses = props.active ? 'calendar-date--active' : '';
	retClasses += props.today ? ' calendar-date--today' : '';
	retClasses += props.selected ? ' calendar-date--selected' : '';
	retClasses += props.size === 'sm' ? ' calendar-date--sm' : (props.size === 'lg' ? ' calendar-date--lg' : ' calendar-date--responsive');

	return retClasses;
});


return { __sfc: true,props, $listeners, listeners, ariaLabel, dateStringAttr, determineClasses, BaseButton }
}

})